<template>
  <div>
    <v-card v-if="user">
      <v-card-title>{{ user.fullname }}</v-card-title>
      <v-card-text>
<div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center pa-0">Кл. дней</th>
              <th class="text-center pa-0">Оклад</th>
              <th class="text-center pa-0">Бонусы</th>
              <th class="text-center pa-0">Авансы</th>
              <th class="text-center pa-0">Штрафы</th>
              <th class="text-center pa-0">Из них недостача</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center pa-1 rg-border">{{ eventsCount }}</td>
              <td class="text-center pa-1 rg-border">{{ allRegular }}&nbsp;₸</td>
              <td class="text-center pa-1 rg-border">{{ allBonus }}&nbsp;₸</td>
              <td class="text-center pa-1 rg-border">{{ allPrepayment }}&nbsp;₸</td>
              <td class="text-center pa-1 rg-border">{{ allDetention }}&nbsp;₸</td>
              <td class="text-center pa-1">{{ allDetentionStoreShortage }}&nbsp;₸</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <h3 class="text-right mr-5 black--text mt-2">Итого: {{ allTotal }}&nbsp;₸</h3>
    </div>
      </v-card-text>
    </v-card>

    <div class="mt-4" v-if="user">
      <v-data-table
        :headers="headers"
        :items="user.events"
        :items-per-page="10"
        dense
        mobile-breakpoint="0"
        class="elevation-1"
      >
      <template v-slot:top>
        <h3 class="ml-3">Явки</h3>
      </template>
      </v-data-table>
    </div>
    <div class="mt-4" v-if="user && user.detentions">
      <v-data-table
        :headers="headers2"
        :items="user.detentions"
        :items-per-page="10"
        dense
        mobile-breakpoint="0"
        class="elevation-1"
      >
      <template v-slot:top>
        <h3 class="ml-3">Нарушения</h3>
      </template>
      </v-data-table>
    </div>
    <div class="mt-4 mb-4" v-if="user && user.prepayments">
      <v-data-table
        :headers="headers3"
        :items="user.prepayments"
        :items-per-page="10"
        dense
        mobile-breakpoint="0"
        class="elevation-1"
        :hide-default-footer="true"
      >
      <template v-slot:top>
        <h3 class="ml-3">Выдачи</h3>
      </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isAuth: false,
    data: null,
    headers: [
      { text: "День", align: "center", value: "date", sortable: false },
      { text: "Точка", align: "center", value: "department", sortable: false },
      { text: "Оклад", align: "center", value: "regular", sortable: false },
      { text: "Бонус", align: "center", value: "bonus", sortable: false },
      { text: "Зарплата", align: "center", value: "salary", sortable: false },
    ],
    headers2: [
      { text: "День", align: "center", value: "date", sortable: false },
      { text: "Категория", align: "center", value: "category", sortable: false },
      { text: "Сумма", align: "center", value: "price", sortable: false },
      { text: "Точка", align: "center", value: "department", sortable: false },
    ],
    headers3: [
      { text: "День", align: "center", value: "date", sortable: false },
      { text: "Комментарии", align: "center", value: "comment", sortable: false },
      { text: "Сумма", align: "center", value: "price", sortable: false },
      { text: "Точка", align: "center", value: "department", sortable: false },
    ],
  }),
  methods: {},
  computed: {
    user: function () {
      return this.$store.getters.user;
    },
    eventsCount: function () {
      return this.user.events.length;
    },
    allRegular: function () {
      let sum = this.user.events.reduce((accumulator, object) => {
        return accumulator + object.regular;
      }, 0);
      return sum
    },
    allBonus: function () {
      let sum = this.user.events.reduce((accumulator, object) => {
        return accumulator + object.bonus;
      }, 0);
      return sum
    },
    allDetention: function () {
      let sum = this.user.detentions.reduce((accumulator, object) => {
        return accumulator + object.price;
      }, 0);
      return sum
    },
    allDetentionStoreShortage: function () {
      let storeShortag = this.user.detentions.filter(x => x.cat_id === 7);
      let sum = storeShortag.reduce((accumulator, object) => {
        return accumulator + object.price;
      }, 0);
      return sum
    },
    allPrepayment: function () {
      let sum = this.user.prepayments.reduce((accumulator, object) => {
        return accumulator + object.price;
      }, 0);
      return sum
    },
    allTotal: function () {
      return this.allRegular + this.allBonus - this.allDetention - this.allPrepayment;
    },
  }
};
</script>


<style scoped>
.rg-border {
  border-right: solid 1px grey;
}
</style>